import React from 'react'
import Box from '../components/Box'

export default function Section16() {
    return (
        <div className="section">
            <h2>Section XVI: Random Group Generator</h2>
            <Box sectionData={'start'} title={'Create a List'} body={`• Tap ‘Action’ and ‘Create Random Groups’. 
            • Tap ‘Group Size’ to change the group size.  
            • Tap ‘Options’ to set whether remaining students should be merged into other groups or left as 
            a small group.`} />
            <Box title={'Share a List'} body={`• Tap the share icon on the top toolbar and select a destination.`} />
            <Box sectionData={'end'} title={'Notes'} body={`• Lists are not saved so be sure to use the share sheet to send them somewhere if you would 
            like a record of the group members.`} />
        </div>
    )
}